import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lineItemPrice", "totalPrice", "totalDisplay"]

  connect() {
    this.calculateTotal()
  }

  calculateTotal() {
    let total = 0

    this.lineItemPriceTargets.forEach(input => {
      const value = parseFloat(input.value) || 0
      total += value
    })

    // Update the hidden total price field
    if (this.hasTotalPriceTarget) {
      this.totalPriceTarget.value = total.toFixed(2)
    }

    // Update the display
    if (this.hasTotalDisplayTarget) {
      this.totalDisplayTarget.textContent = this.formatNumber(total)
    }
  }

  formatNumber(num) {
    return num.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }
}
